import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { AuthHelper } from '../utils';
import { removeToken } from '../utils/token';

type IProps = Omit<RouteProps, 'render'>;

const AuthRoute: React.FC<IProps> = ({ component: Component, ...rest }) => {
  const renderRoute = (props) => {
    if (!AuthHelper.isAuthenticated) {
      return <Component {...props} />;
    }

    if (props.location.pathname.startsWith('/reset-password/')) {
      removeToken();
      return <Component {...props} />;
    }

    return <Redirect to="/" />;
  };

  return <Route {...rest} render={renderRoute} />;
};

export default AuthRoute;
